import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
	return (
		<footer className="footer">
			<div className="footer-main">
				<div className="container footer-grid">

					{/* Brand */}
					<div className="footer-col footer-brand-col">
						<div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
							<svg width="34" height="34" viewBox="0 0 40 40" fill="none">
								<rect width="40" height="40" rx="8" fill="#c45c14"/>
								<path d="M8 22l12-12 12 12" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
								<path d="M12 18v10h6v-6h4v6h6V18" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
							<div>
								<div style={{ fontWeight: 800, fontSize: 14, color: '#fff' }}>A-Z Home Improvement</div>
								<div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)' }}>Licensed Remodeling Contractor</div>
							</div>
						</div>
						<p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13, lineHeight: 1.6, margin: '0 0 14px' }}>
							Phoenix, AZ's trusted home remodeling and renovation contractor. Quality craftsmanship, honest pricing, on-time delivery.
						</p>
						<div className="footer-social">
							<a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Facebook">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
							</a>
							<a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="Instagram">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor"/></svg>
							</a>
							<a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="LinkedIn">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
							</a>
							<a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label="X / Twitter">
								<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
							</a>
						</div>
					</div>

					{/* Services */}
					<div className="footer-col">
						<h4 className="footer-heading">Services</h4>
						<ul className="footer-links">
							<li><Link to="/services">Kitchen Remodeling</Link></li>
							<li><Link to="/services">Bathroom Renovation</Link></li>
							<li><Link to="/services">Flooring &amp; Tile</Link></li>
							<li><Link to="/services">Interior &amp; Exterior Painting</Link></li>
							<li><Link to="/services">Windows &amp; Doors</Link></li>
							<li><Link to="/services">Decks &amp; Patios</Link></li>
							<li><Link to="/services">General Renovation</Link></li>
						</ul>
					</div>

					{/* Company */}
					<div className="footer-col">
						<h4 className="footer-heading">Company</h4>
						<ul className="footer-links">
							<li><Link to="/about">About Us</Link></li>
							<li><Link to="/gallery">Our Work</Link></li>
							<li><Link to="/service-areas">Service Areas</Link></li>
							<li><Link to="/faq">FAQ</Link></li>
							<li><Link to="/compliance">Licensing &amp; Compliance</Link></li>
							<li><Link to="/contact">Get a Free Quote</Link></li>
						</ul>
					</div>

					{/* Contact */}
					<div className="footer-col">
						<h4 className="footer-heading">Contact</h4>
						<ul className="footer-contact-list">
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ minWidth: 14, marginTop: 2 }}><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0Z" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="1.5"/></svg>
								3842 W. McDowell Rd, Suite 110<br />Phoenix, AZ 85009
							</li>
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ minWidth: 14 }}><path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C9.61 21 3 14.39 3 6.5a1 1 0 0 1 1-1H7.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
								<a href="tel:+16023902536">(602) 390-2536</a>
							</li>
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ minWidth: 14 }}><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="m2 7 10 7 10-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
								<a href="mailto:info@azhomefundingservices.com">info@azhomefundingservices.com</a>
							</li>
							<li>
								<svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ minWidth: 14 }}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/><path d="M12 8v4l2 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
								Mon–Fri 7AM–6PM · Sat 8AM–3PM
							</li>
						</ul>
					</div>

				</div>
			</div>

			<div className="footer-disclosure">
				<div className="container">
					<p>
						<strong>SMS Disclosure:</strong> By opting in on our website, you consent to receive text messages from A-Z HOME IMPROVEMENT LLC
						regarding remodeling estimates, appointment reminders, project updates, and promotional offers.
						Msg &amp; data rates may apply. Frequency varies. Reply <strong>STOP</strong> to opt out, <strong>HELP</strong> for help.
						Consent is not required to receive home improvement services.
						We do not sell or share mobile numbers with third parties for marketing.
					</p>
				</div>
			</div>

			<div className="footer-bottom">
				<div className="container footer-bottom-inner">
					<p>© {new Date().getFullYear()} A-Z HOME IMPROVEMENT LLC. All rights reserved. | AZ ROC License #XXXXX8142</p>
					<div>
						<Link to="/privacy">Privacy Policy</Link>
						<Link to="/terms">Terms</Link>
						<Link to="/sms-policy">SMS Policy</Link>
						<Link to="/opt-out">Opt-Out</Link>
						<Link to="/accessibility">Accessibility</Link>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
